import { render } from "./voiceprintCard.vue?vue&type=template&id=4a3ea81a"
import script from "./voiceprintCard.vue?vue&type=script&lang=js"
export * from "./voiceprintCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__